export default __webpack_public_path__ + "static/media/OddsEngine3.06d8cdae.png";